/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownRightIcon16Light = forwardRef('ArrowDRadiusDownRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 2.5A5.5 5.5 0 0 0 7.5 8h6.293l-3.647-3.646a.5.5 0 0 1 .708-.708l3.651 3.652a1.7 1.7 0 0 1 0 2.404l-3.651 3.652a.5.5 0 0 1-.708-.708L13.793 9H7.5A6.5 6.5 0 0 1 1 2.5a.5.5 0 0 1 1 0Z" })));
});
